import type { ReactNode } from "react";

/**
 * A decorative emoji in front of a heading or a stat, sized to the text around it. Hidden from
 * screen readers: the words next to it already say what it means.
 */
export function Emoji({ children }: { children: ReactNode }) {
  return (
    <span className="emoji" aria-hidden="true">
      {children}
    </span>
  );
}
